import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

export type CalendarUnsavedChangesDialogResult = 'save' | 'discard' | 'cancel';

export interface CalendarUnsavedChangesDialogData {
  can_save: boolean;
}

@Component({
  selector: 'app-calendar-unsaved-changes-dialog',
  templateUrl: './calendar-unsaved-changes-dialog.component.html',
  styleUrl: './calendar-unsaved-changes-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButton, MatIcon],
})
export class CalendarUnsavedChangesDialogComponent {
  private readonly dialog_ref = inject(MatDialogRef<CalendarUnsavedChangesDialogComponent, CalendarUnsavedChangesDialogResult>);
  readonly data = inject<CalendarUnsavedChangesDialogData>(MAT_DIALOG_DATA);

  save(): void {
    this.dialog_ref.close('save');
  }

  discard(): void {
    this.dialog_ref.close('discard');
  }

  cancel(): void {
    this.dialog_ref.close('cancel');
  }
}
